import { useNavigate, useParams, useOutletContext} from "react-router";
import { useSearchParams } from "react-router-dom";

export function withRouter( Component ) {
    return props => <Component {...props} outlet={useOutletContext()} navigate={useNavigate()}  searchParams={useSearchParams()} params={useParams()} />;
}